export { default } from "./documentObjectType";
